import React, {useContext, useEffect, useState} from 'react'
import {AppContext} from '../app/app'
import {initGame} from '../launch/launch'
import Box from '@mui/material/Box'
import classnames from 'classnames'
import {destroyGame} from '../launch/launch'

import './demo.css'

const Demo = () => {
    const {isGameLoading} = useContext(AppContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        initGame({
            isDemo: true,
        })

        return function destroy() {
            destroyGame()
        }
    }, [])

    useEffect(() => {
        if (!isGameLoading) {
            setLoading(false)
        }
    }, [isGameLoading])

    return (
        <Box
            id="game"
            sx={{width: '100%', height: '100%'}}
            className={classnames('demo', {
                ready: !loading,
            })}
        />
    )
}

export default Demo
